module.exports = "/static/assets/c4379c5eb21b7cf9b9c94055dde0b582.svg";